import type { SwitchProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

import { alpha } from '@mui/material/styles';

const Switch = (theme: Theme) => {
  const isLight = theme.palette.mode === 'light';

  const rootStyle = (ownerState: SwitchProps) => ({
    height: 38,
    padding: '9px 13px 9px 12px',
    width: 58,
    ...(ownerState.size === 'small' && {
      height: 24,
      padding: '4px 8px 4px 7px',
      width: 40,
    }),
    '& .MuiSwitch-switchBase': {
      left: 3,
      padding: 12,
      ...(ownerState.size === 'small' && {
        padding: 7,
      }),
      '&.Mui-checked': {
        '&+.MuiSwitch-track': { opacity: 1 },
        transform: 'translateX(13px)',
        ...(ownerState.size === 'small' && {
          transform: 'translateX(9px)',
        }),
      },
      '&.Mui-disabled': {
        '& .MuiSwitch-thumb': { opacity: isLight ? 1 : 0.48 },
        '&+.MuiSwitch-track': { opacity: 0.48 },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      color: `${theme.palette.common.white} !important`,
      height: 14,
      width: 14,
      ...(ownerState.size === 'small' && {
        height: 10,
        width: 10,
      }),
    },
    '& .MuiSwitch-track': {
      backgroundColor: alpha(theme.palette.grey[500], 0.48),
      borderRadius: 14,
      opacity: 1,
    },
  });

  return {
    MuiSwitch: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: SwitchProps }) =>
          rootStyle(ownerState),
      },
    },
  };
};

export default Switch;
